// import React, { useState } from "react";
// import "./Test.css";

// const placeholder = "https://via.placeholder.com/500"; // fallback

// const PropertyGallery = ({ property }) => {
//   const images = property?.images || [];
//   // main image: پہلے image، ورنہ property.mainImage، ورنہ placeholder
//   const [mainImage, setMainImage] = useState(
//     images[0] || property?.mainImage || placeholder
//   );

//   // indexes: main = 0, rightTop = 1, rightBottom = 2, thumbs = 3..7 (max 5)
//   const rightTop = images[1] || images[0] || property?.mainImage || placeholder;
//   const rightBottom = images[2] || images[1] || images[0] || placeholder;
//   const thumbs = images.slice(3, 8); // up to 5 thumbnails
//   const extraCount = images.length > 8 ? images.length - 8 : 0;

//   return (
//     <div className="gallery-wrapper">
//       <div className="gallery-grid">
//         {/* Main large image (500x500) */}
//         <div
//           className="gallery-main"
//           onClick={() => {
//             /* optional: open lightbox */
//           }}
//         >
//           <img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt={property?.propertyName || "main"} />
//         </div>

//         {/* Right column: two 250x250 images stacked */}
//         <div className="gallery-right">
//           <div className="right-img" onClick={() => setMainImage(rightTop)}>
//             <img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt="right top" />
//           </div>
//           <div className="right-img" onClick={() => setMainImage(rightBottom)}>
//             <img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt="right bottom" />
//           </div>
//         </div>

//         {/* Thumbnails row (five 200x200) spanning full width under both */}
//         <div className="gallery-thumbs">
//           {thumbs.length > 0 ? (
//             thumbs.map((img, i) => (
//               <div
//                 className="thumb-item"
//                 key={i}
//                 onClick={() => setMainImage(img)}
//               >
//                 <img src={img} alt={`thumb-${i}`} />
//                 {/* اگر آخری تھمب ہو اور مزید امیجز ہوں تو +N اوورلے دکھاؤ */}
//                 {i === thumbs.length - 1 && extraCount > 0 && (
//                   <div className="more-overlay">+{extraCount}</div>
//                 )}
//               </div>
//             ))
//           ) : (
//             // اگر کوئی تھمب نہ ہو تو empty placeholders دکھائیں (optional)
//             <>
//               <div className="thumb-item placeholder"><img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt="ph"/></div>
//               <div className="thumb-item placeholder"><img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt="ph"/></div>
//               <div className="thumb-item placeholder"><img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt="ph"/></div>
//               <div className="thumb-item placeholder"><img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt="ph"/></div>
//               <div className="thumb-item placeholder"><img src={"https://rafay-bucket-aqejdjwejfhwe-wejfwef.s3.us-east-1.amazonaws.com/Yoohoo-Frontend/images/property/e17890e6-b7f6-42f6-963c-9d8c9e714aab.jpeg"} alt="ph"/></div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PropertyGallery;

import React, { useState } from "react";
import "./Test.css";

const placeholder = "https://via.placeholder.com/500"; // fallback

const PropertyGallery = ({ property }) => {
  const images = property?.images || [];

  // Main image: پہلے image → property.mainImage → placeholder
  const [mainImage, setMainImage] = useState(
    images[0] || property?.mainImage || placeholder
  );

  // Right column images
  const rightTop = images[1] || placeholder;
  const rightBottom = images[2] || placeholder;

  // Thumbnails (max 5 → from index 3 onward)
  const thumbs = images.slice(3, 8);
  const extraCount = images.length > 8 ? images.length - 8 : 0;

  return (
    <div className="gallery-wrapper">
      <div className="gallery-grid">
        {/* Main large image (500x500) */}
        <div className="gallery-main" onClick={() => setMainImage(images[0])}>
          <img src={mainImage} alt={property?.propertyName || "main"} />
        </div>

        {/* Right column: two 250x250 images */}
        <div className="gallery-right">
          <div className="right-img" onClick={() => setMainImage(rightTop)}>
            <img src={rightTop} alt="right top" />
          </div>
          <div className="right-img" onClick={() => setMainImage(rightBottom)}>
            <img src={rightBottom} alt="right bottom" />
          </div>
        </div>

        {/* Thumbnails row (five 200x200) */}
        <div className="gallery-thumbs">
          {thumbs.length > 0 ? (
            thumbs.map((img, i) => (
              <div
                className="thumb-item"
                key={i}
                onClick={() => setMainImage(img)}
              >
                <img src={img} alt={`thumb-${i}`} />
                {i === thumbs.length - 1 && extraCount > 0 && (
                  <div className="more-overlay">+{extraCount}</div>
                )}
              </div>
            ))
          ) : (
            // اگر کوئی thumb نہ ہو تو placeholders دکھائیں
            Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="thumb-item placeholder">
                <img src={placeholder} alt={`ph-${i}`} />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyGallery;
